import React from 'react';

const Button = ({ name, link = '' }) => {
    return (
        <div className='mt-3'>
            <a href={link} target='_blank' className='btn mr-5 capitalize'>{name}</a>
        </div>
    )
}

export default Button;
